var React = require('react');

function StackOverflow (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM0.7,9.1l0,3.7c0,0.9,0.8,1.7,1.7,1.7l11,0c0.9,0,1.7-0.8,1.7-1.7","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"1.6","y1":"6.5","x2":"12.5","y2":"12.3","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"2","y1":"3.5","x2":"14.2","y2":"9.6","key":2}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"3.7","y1":"1.4","x2":"15.3","y2":"7.4","key":3})]));
}

StackOverflow.displayName = "StackOverflow";

StackOverflow.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = StackOverflow;

StackOverflow.default = StackOverflow;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/stackOverflow.svg
// module id = ../icon/src/icons/stackOverflow.svg
// module chunks = 0